import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalSequenciasInutilizadas } from '@/features/relatorio/page/fiscal/relacao-sequencias-inutilizadas/RelatorioFiscalSequenciasInutilizadas';

export const Route = createFileRoute('/a/relatorio/fiscal/relacao-sequencias-inutilizadas')({
    component: RelatorioFiscalSequenciasInutilizadas,
});
